import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";

export default {
    async login(param: types.ReqLogin): Promise<types.ResCommon> {
        const res = {} as types.ResCommon;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/auth/login", param, { withCredentials: false });

            const user = userStore();
            user.setAccessToken(response.data.accessToken);
            user.setRefreshToken(response.data.refreshToken);

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
    async logout(): Promise<types.BaseResponse> {
        const res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/auth/logout", {}, { withCredentials: false });
            const user = userStore();
            user.$reset();
            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },

    async refresh(refreshToken: types.ReqRefreshToken): Promise<types.ResCommon> {
        const res = {} as types.ResCommon;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/auth/refresh", refreshToken, { withCredentials: false });

            return response.data;
        } catch (error) {
            console.error(error);
        }
        return res;
    },
};
